import { render, staticRenderFns } from "./RelatorioCotasRegiaoListFiltro.vue?vue&type=template&id=02298010"
import script from "./RelatorioCotasRegiaoListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasRegiaoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports